import { render, staticRenderFns } from "./MatomoEvents.vue?vue&type=template&id=274c96aa&"
import script from "./MatomoEvents.vue?vue&type=script&lang=js&"
export * from "./MatomoEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatomoEvents.vue"
export default component.exports